"use client";

import { useModal } from "@/context/ModalContext";

type BookTourButtonVariant = "light" | "dark";

type BookTourButtonProps = {
  variant?: BookTourButtonVariant;
  className?: string;
};

const variantClasses: Record<BookTourButtonVariant, string> = {
  // Light button for dark surfaces (e.g. the primary-dark details panel)
  light:
    "bg-sand-100 text-primary-dark hover:bg-primary-light hover:text-white",
  // Dark button for light surfaces (e.g. the sand-100 call to action column)
  dark: "bg-primary-dark text-sand-100 hover:bg-primary-light hover:text-white",
};

export const BookTourButton = ({
  variant = "light",
  className = "",
}: BookTourButtonProps) => {
  const { openModal } = useModal();

  return (
    <button
      type="button"
      onClick={openModal}
      className={`bookTourBtn self-start rounded-full font-open-sans font-medium text-md sm:text-lg px-xl py-sm transition-colors ${variantClasses[variant]} ${className}`}
    >
      Book Tour
    </button>
  );
};
